module.exports = require("node-notifier");


//////////////////
// WEBPACK FOOTER
// external "node-notifier"
// module id = 85
// module chunks = 0